import * as Yup from 'yup'

export const createAddressIntialValues = {
    same: false,
    address_id: "",
    address_type: "",
    city: "",
    country: "",
    is_default: 0,
    shipping_address: "",
    shipping_address1: "",
    shipping_city: "",
    shipping_company_name: "",
    shipping_country: "",
    shipping_fax: "",
    shipping_first_name: "",
    shipping_last_name: "",
    shipping_middle_name: "",
    shipping_mobile: "",
    shipping_phone: "",
    shipping_state: "",
    shipping_zipcode: "",
    state: "",
    user_id: ""
}
export const createCustomerIntialValues = (values) => {
    return {
        first_name: values.first_name || "",
        last_name: values.last_name || "",
        company_name: values.company_name || "",
        email: values.email || "",
        password: values.password || "",
        middle_name: values.middle_name || "",
        shipping_first_name: values.shipping_first_name || "",
    }
}

export const createCustomerVS = Yup.object({
    first_name: Yup.string().required('This field is required'),
    last_name: Yup.string().required('This field is required'),
    email: Yup.string().required('This field is required'),
    password: Yup.string()
        .required('This field is required')
        .matches(/^(?=.{8,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/, "Password must have a small letter, a capital letter, a number, and a symble."),

})
export const createAddressVS = Yup.object({
    shipping_first_name: Yup.string().required("This field is required"),
    shipping_last_name: Yup.string().required("This field is required"),
    shipping_company_name: Yup.string().required("This field is required"),
    shipping_address: Yup.string().required("This field is required"),
    shipping_city: Yup.string().required("This field is required"),
    shipping_country: Yup.string().required("This field is required"),
    shipping_state: Yup.string().required("This field is required"),
    shipping_mobile: Yup.string()
        .required("This field is required")
        .min(8, 'Invalid number')
        .max(12, 'Invalid number')
})


export const CustomerInfoIntialValues = (values) => {
    return {
        shipping_first_name: values.shipping_first_name || "",
        shipping_last_name: values.shipping_last_name || "",
        shipping_company_name: values.shipping_company_name || "",
        shipping_phone: values.shipping_phone || "",
        shipping_address: values.shipping_address || "",
        shipping_address1: values.shipping_address1 || "",
        streetAddress3: values.streetAddress3 || "",
        shipping_country: values.shipping_country || "",
        shipping_state: values.shipping_state || "",
        shipping_city: values.shipping_city || "",
        shipping_zipcode: values.shipping_zipcode || "",
        saveToCustomerAddressBook: values.saveToCustomerAddressBook || "",
    }
}

export const CustomerInfoValidationSchema = Yup.object({
    shipping_first_name: Yup.string().required('This field is required'),
    shipping_last_name: Yup.string().required('This field is required'),
    shipping_phone: Yup.string().required('This field is required'),
    shipping_company_name: Yup.string().required('This field is required'),
    shipping_address1: Yup.string().required('This field is required'),
    shipping_address: Yup.string().required('This field is required'),
    shipping_country: Yup.string().required('This field is required'),
    shipping_city: Yup.string().required('This field is required'),
    shipping_zipcode: Yup.string().required('This field is required'),
    saveToCustomerAddressBook: Yup.string().required('This field is required'),
})
